export type IExperience = {
  title: string;
  employer: string;
  location: string;
  startDate: Date;
  endDate?: Date;
  description: {
    summary?: string;
    bullets?: string[];
  };
  extraProjects?: {
    projectName: string;
    description: {
      summary?: string;
      bullets?: string[];
    }
  }[]
};

export const experienceData: IExperience[] = [
  {
    title: "Senior Software Engineer/Developer",
    employer: "Health Research, Inc.",
    location: "Albany, NY",
    startDate: new Date("2024-07-17T00:00:00.00-04:00"),
    description: {
      bullets: [
        "Maintain and support Health Commerce System for NYS Department of Health.",
        "Analyze legacy apps, collectrequirements,redesign apps and backend API’s.",
        "Develop and maintain internal packages.",
        "Provide detailed UI design aligned with the organization’s visual identity and branding guidelines.",
        "Review merge requests as GitLab project maintainer, ensuring code quality and consistency.",
        "Define branching strategy to improve code collaboration and reduce integration issues",
      ]
    }
  },
  {
    title: "Web Developer",
    employer: "Software Engineering Research Group, University at Albany",
    startDate: new Date("2020-01-01T00:00:00.00-05:00"),
    endDate: new Date("2024-07-16T00:00:00.00-04:00"),
    location: "Albany, NY",
    description: {
      summary: "Collaborate with team to deploy new features and collect requirements via communicating with clients. Responsible for the ETL process, and ensuring clean and clear visualization in the front-end."
    },
    extraProjects: [
      {
        projectName: "Knowledge Forum 6",
        description: {
          summary: "As one of the leading developers, actively engage in discussions with clients regarding new learning analytic solutions and with colleagues regarding challenges in implementation, resolve production issues, and mentor new developers.",
        }
      }
    ]
  },
  {
    title: "Research Assistant",
    startDate: new Date("2021-12-01T00:00:00.00-05:00"),
    endDate: new Date("2024-07-16T00:00:00.00-04:00"),
    employer: "University at Albany, SUNY",
    location: "Albany, NY",
    description: {
      summary:
        "Contributed to two research projects, involving designing experiments, conducting ETL (Extract, Transform, Load) processes on data, applying various machine learning algorithms, and analyzing the results.",
      bullets: [
        "Design, implement, and conduct experiments, following analyzing the results and create visualization.",
        "Apply regression machine learning algorithms to predict software reliability.",
        "Apply large language models’ embedding in novelty idea detection"
      ],
    },
    extraProjects: [
      {
        projectName: "Discourse Analysis Framework",
        description: {
          summary: "Develop a framework that combines embeddings from Large Language Models with semantic role labeling to offer explainable and actionable topic discovery, facilitating discourse analysis."
        }
      },
      {
        projectName: "Adaptive Reliability Prediction Framework (AdaRel)",
        description: {
          summary: "Developed an adaptive software reliability prediction framework with a specialization in time series forecasting and anomaly detection",
          bullets: [
            "Published and presented to QRS2024"
          ]
        }
      }
    ]
  },
  {
    title: "Teaching Assistant",
    employer: "University at Albany, SUNY",
    location: "Albany, NY",
    startDate: new Date("2020-08-01T00:00:00.00-04:00"),
    endDate: new Date("2021-12-01T00:00:00.00-05:00"),
    description: {
      bullets: [
        "Software Engineering (graduate level & 400 level)",
        "Algorithms and Data Structures (graduate level & 400 level)",
        "Introduction to Programming (100 level)"
      ]
    }
  }
];
